import axios from 'axios';
import {
    ADD_CLAIMED_ITEM,
    EMPTY_CLAIMED_ITEMS,
    PROFILE_LOAD,
    REMOVE_CLAIMED_ITEM,
    UPDATE_CLAIMED_ITEMS,
} from '../template/AppTemplateActions';

export const getSlab = (id, callback) => async () => {
    let config = {
        url: `/embeddeds/${id}/slab`,
        errorMessage: 'Something went wrong while loading Slab',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const getBundle = (id, callback) => async () => {
    let config = {
        url: `/embeddeds/${id}/bundle`,
        errorMessage: 'Something went wrong while loading Pack',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const getIndustrialPack = (id, callback) => async () => {
    let config = {
        url: `/embeddeds/${id}/industrial_pack`,
        errorMessage: 'Something went wrong while loading Pack',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const getLumber = (id, callback) => async () => {
    let config = {
        url: `/embeddeds/${id}/lumber`,
        errorMessage: 'Something went wrong while loading Lumber',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const loadSlabs = (params, callback) => async () => {
    let config = {
        url: '/embeddeds/slabs',
        params: params,
        errorMessage: 'Something went wrong while loading Slabs',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const searchNumbers = (q, callback, params) => async () => {
    let config = {
        url: '/embeddeds/numbers',
        params: {filters: {q, ...params, override: true}},
        errorMessage: 'Something went wrong while searching Slabs by Number',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const searchCharacters = (q, callback, params) => async () => {
    let config = {
        url: '/characters/search',
        params: {filters: {q, ...params, override: true}},
        errorMessage: 'Something went wrong while searching Slabs by Character',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const searchCategories = (q, callback, params, formulas) => async () => {
    let config = {
        url: '/categories/search',
        params: {filters: {q, ...params, override: true}, formulas},
        errorMessage: 'Something went wrong while searching Slabs by Category',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const searchTags = (q, callback, params) => async () => {
    let config = {
        url: '/tags/search',
        params: {filters: {q, ...params, override: true}},
        errorMessage: 'Something went wrong while searching Tags',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const searchSpecies = (q, callback, params) => async () => {
    let config = {
        url: '/trees/search',
        params: {filters: {q, ...params, override: true}, filter_removed: false},
        errorMessage: 'Something went wrong while searching Slabs by Species',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const searchLocations = (q, callback, params) => async () => {
    let config = {
        url: '/locations/search',
        params: {filters: {q, ...params, override: true}},
        errorMessage: 'Something went wrong while searching Slabs by Location',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const searchAllowedCycles = (q, callback, params) => async () => {
    let config = {
        url: '/allowed_cycles/search',
        params: {filters: {q, ...params, override: true}},
        errorMessage: 'Something went wrong while searching Slabs by Status',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const createOrder = (order, params, callback, errorCallback) => async () => {
    let config = {
        url: '/orders',
        method: 'POST',
        data: {order},
        params: {...params},
        errorMessage: 'Something went wrong while creating Order',
    };

    await axios.request(config)
        .then(callback)
        .catch(errorCallback);
};

export const getOrderByTransactionId = (id, callback) => async () => {
    let config = {
        url: '/orders/show_by_transaction_id',
        params: {transaction_id: id},
        errorMessage: 'Something went wrong while loading Order',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const loadTrees = (callback) => async () => {
    let config = {
        url: '/embeddeds/trees',
        params: {page: 1, per_page: 10},
        errorMessage: 'Something went wrong while loading Species',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const loadFilters = (type, filter_id, callback) => async () => {
    const config = {
        url: '/filters/items',
        params: {type, filter_id},
        errorMessage: 'Something went wrong while loading Filters',
    };
    const result = await axios.request(config);

    callback(result.data);
};

export const loadThicks = (callback) => async () => {
    const config = {
        url: '/thicks/search',
        errorMessage: 'Something went wrong while loading Thicknesses',
    };

    const result = await axios.request(config);
    callback(result.data ? result.data : []);
};

export const getFilter = (filterId, callback) => async () => {
    const config = {
        url: `/embeddeds/filter`,
        params: {filter_id: filterId},
        errorMessage: 'Something went wrong while loading Filter',
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const loadResources = (itemParams, itemType, callback) => async () => {
    if (itemParams.menu) delete itemParams.menu;
    const type = itemType === 'boards_and_beams' ? 'lumbers' : itemType;
    const config = [
        {
            url: `/embeddeds/${type.toLowerCase()}`,
            params: itemParams,
            errorMessage: `Something went wrong while loading ${type.toUpperCase()}`,
        },
        {
            url: '/embeddeds/trees',
            params: itemParams,
            errorMessage: 'Something went wrong while loading Species',
        },
        {
            url: '/embeddeds/categories',
            params: itemParams,
            errorMessage: 'Something went wrong while loading Categories',
        },
        {
            url: '/embeddeds/tags',
            params: itemParams,
            errorMessage: 'Something went wrong while loading Tags',
        },
        {
            url: '/embeddeds/locations',
            params: itemParams,
            errorMessage: 'Something went wrong while loading Locations',
        },
        {
            url: '/embeddeds/characters',
            params: itemParams,
            errorMessage: 'Something went wrong while loading Characters',
        },
        {
            url: '/embeddeds/cycles',
            params: itemParams,
            errorMessage: 'Something went wrong while loading Cycles',
        },
    ];
    if (itemParams.filters.type === 'industrial_packs') {
        config.push({
            url: '/embeddeds/gradings',
            params: itemParams,
            errorMessage: 'Something went wrong while loading Gradings',
        });
    }
    const actions = config.map(c => axios.request(c));
    const all = await axios.all(actions);
    Promise.all(all).then(allResponses => callback(
            {
                items: allResponses[0].data,
                trees: allResponses[1].data,
                categories: allResponses[2].data,
                tags: allResponses[3].data,
                locations: allResponses[4].data,
                characters: allResponses[5].data,
                cycles: allResponses[6].data,
                gradings: allResponses[7] && allResponses[7].data,
            },
        ),
    );
};

export const getClientInfo = (publicUrl, type, ids, callback) => async (dispatch) => {
    const config = {
        url: '/profile',
        params: {
            public_url: publicUrl,
            ids: ids, type: type,
        },
        errorMessage: 'Something went wrong while loading Profile',
    };
    const result = await axios.request(config);
    dispatch({
        type: PROFILE_LOAD,
        profile: result.data,
    });

    callback(result.data);
};

export const addClaimedItem = (claimedItem) => {
    return {
        type: ADD_CLAIMED_ITEM,
        claimedItem,
    };
};

export const removeClaimedItem = (claimedItem) => {
    return {
        type: REMOVE_CLAIMED_ITEM,
        claimedItem,
    };
};

export const updateClaimedItems = (claimedItems) => {
    return {
        type: UPDATE_CLAIMED_ITEMS,
        claimedItems,
    };
};

export const emptyClaimedItems = () => {
    return {
        type: EMPTY_CLAIMED_ITEMS,
    };
};

export const payByStripe = (clientId, paymentMethod, items, total, callback) => async () => {
    const config = {
        url: '/stripe/pay_by_stripe',
        errorMessage: 'Something went wrong while processing Stripe payment',
        method: 'POST',
        data: {
            payment_method: paymentMethod,
            items: items,
            client_id: clientId,
            total: total,
        },
    };
    const result = await axios.request(config);
    callback(result.data);
};
export const payBySquare = (clientId, paymentMethod, items, resource, callback) => async () => {
    const config = {
        url: '/square/pay_by_square',
        errorMessage: 'Something went wrong while processing Square payment',
        method: 'POST',
        data: {
            payment_method: paymentMethod,
            items: items,
            client_id: clientId,
            resource: resource,
        },
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const getApiKey = (clientId, callback) => async () => {
    const config = {
        url: '/stripe/get_api_key',
        params: {
            client_id: clientId,
        },
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const getSquareCredentials = (clientId, callback) => async () => {
    const config = {
        url: '/square/get_square_credentials',
        errorMessage: 'Something went wrong while loading Square Data',
        params: {
            client_id: clientId,
        },
    };
    const result = await axios.request(config);
    callback(result.data);
};

export const saveSurveyAnswer = (data, callback) => async () => {
    let config = {
        data,
        method: 'POST',
        url: '/embed_survey',
    };

    await axios.request(config).then(callback);
};

export const checkIfSurveyAlreadyAnswered = (params, callback) => async () => {
    let config = {
        params,
        url: '/embed_survey/answered',
    };

    const result = await axios.request(config);
    callback(result.data);
};

export const getItemsTaxes = (data, callback) => async () => {
    let config = {
        data,
        method: 'POST',
        url: '/square/get_items_taxes',
    };

    const result = await axios.request(config);
    callback(result.data);
};


// WEBPACK FOOTER //
// ./src/containers/embeddable/EmbeddableApi.js